import { FC } from 'react';

import './style.scss';

export const UserProfileSkeleton: FC = () => {
  return (
    <div className="svg-skeleton user-profile-skeleton">
      <svg width="343" height="161" viewBox="0 0 343 161" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="44" cy="44.5" r="44" fill="#e6e6e6" />
        <rect x="104" y="30.5" width="72" height="28" rx="2" fill="#e6e6e6" />
        <rect x="187.5" y="30.5" width="72" height="28" rx="2" fill="#e6e6e6" />
        <rect x="271" y="30.5" width="72" height="28" rx="2" fill="#e6e6e6" />
        <rect y="96.5" width="223" height="16" rx="2" fill="#e6e6e6" />
        <rect y="120.5" width="131" height="16" rx="2" fill="#e6e6e6" />
        <rect y="144.5" width="72" height="16" rx="2" fill="#e6e6e6" />
      </svg>
    </div>
  );
};
